"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseUtils = require("@wix/photography-client-lib/dist/src/utils/baseUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenShareButtons =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenShareButtons, _React$Component);

  function FullscreenShareButtons(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.buttons = [];
    return _this;
  }

  var _proto = FullscreenShareButtons.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    try {
      var focusedButton = this.props.focus;

      if (focusedButton > 0) {
        // this.buttonsContainer.focus();
        this.buttons[focusedButton - 1].focus();
      }
    } catch (e) {
      console.warn('Cannot focus on share icon', this.props.focus, e);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var shareArr = ['facebook', 'twitter', 'pinterest', 'tumblr'];
    if (!_baseUtils.baseUtils.isiOS()) shareArr.push('email');

    if (this.props.item.type === 'text') {
      shareArr.splice(2, 1);
    }

    var buttons = shareArr.map(function (network, idx) {
      return _react["default"].createElement("button", {
        className: 'fullscreen-social-' + network + ' progallery-svg-font-icons-' + network + ' has-custom-focus',
        ref: function ref(button) {
          return _this2.buttons[idx] = button;
        },
        onClick: function onClick() {
          return _this2.props.itemActions.share(network, _this2.props.item, 'fullscreen');
        },
        key: network + '-share-icon',
        "data-hook": network + '-share-hook',
        title: "Share on " + network,
        "aria-label": "Share on " + network + ", " + (idx + 1) + " of " + shareArr.length,
        "aria-live": "assertive",
        role: "button",
        tabIndex: -1
      });
    });
    return _react["default"].createElement("div", {
      className: "fullscreen-social-items-container",
      "aria-live": "assertive",
      ref: function ref(ele) {
        return _this2.buttonsContainer = ele;
      },
      tabIndex: -1
    }, buttons);
  };

  return FullscreenShareButtons;
}(_react["default"].Component);

var _default = FullscreenShareButtons;
exports["default"] = _default;